import { gql, useQuery } from "@apollo/client";
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { BreadCrumb, BreadCrumbProp } from "../../components/light/Breadcrumb";
import { Content } from "../../components/light/Content";
import { SectionBlock } from "../../components/light/SectionBlock";
import { Loading } from "../../components/Loading";
import {
  InlineTabContentProduct,
  InlineTabProduct,
} from "../applications/products/item/components/InlineTabProduct";
import { useTranslation } from "react-i18next";

const BreadCrumbItems: BreadCrumbProp[] = [
  { text: "options", to: "#" },
  { text: "brands", to: "#" },
  { text: "my brand", to: "/options/brand/list" },
];

const QUERY_APPROVED = gql`
  query merchantBrandApproveList {
    merchantBrandApproveList {
      id
      alias
      name
      banner
      picture
      description
      status
    }
  }
`;

const QUERY_REJECTED = gql`
  query merchantBrandRejectList {
    merchantBrandRejectList {
      id
      alias
      name
      banner
      picture
      description
      status
    }
  }
`;

const QUERY_REVIEW = gql`
  query merchantBrandRequestList {
    merchantBrandRequestList {
      id
      alias
      name
      banner
      picture
      description
      status
    }
  }
`;

export function MyBrandScreen() {
  const { t } = useTranslation();
  const { replace } = useHistory();
  const query = new URLSearchParams(window.location.search);
  const [status, setStatus] = useState(query.get("filter") === null ? "approved" : query.get("filter"));
  const queryApproved = useQuery(QUERY_APPROVED, {
    fetchPolicy: "no-cache",
  });
  const queryRejected = useQuery(QUERY_REJECTED, {
    fetchPolicy: "no-cache",
  });
  const queryReview = useQuery(QUERY_REVIEW, {
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    const replaceURL = () => {
      if (query.get("filter") === null) {
        replace({
          pathname: "/options/brand/list",
          search: "?filter=approved",
        });
      }
    }
    replaceURL();
  }, [query, replace])

  if (
    queryReview.loading ||
    queryReview.data === undefined ||
    queryApproved.loading ||
    queryApproved.data === undefined ||
    queryRejected.loading ||
    queryRejected.data === undefined
  ) {
    return (
      <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
        <Loading />
      </Content>
    );
  }

  return (
    <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
      <div className="row">
        <div className="col-md-6">
          <SectionBlock title={t('brand_list')} transparent={true}>
            <div className="row">
              <div className="col-md-12 text-right">
                <Link
                  to="/options/brand/create"
                  className="btn btn-secondary btn-sm"
                >
                  {t('create')}
                </Link>
              </div>
              <div className="col-md-12">
                <InlineTabProduct
                  contentChildren={
                    <RenderData
                      items={
                        status === "approved"
                          ? queryApproved.data.merchantBrandApproveList
                          : status === "reviewing"
                            ? queryReview.data.merchantBrandRequestList
                            : queryRejected.data.merchantBrandRejectList
                      }
                    />
                  }
                >
                  <InlineTabContentProduct
                    alias="?filter=approved"
                    actived={status === "approved"}
                    onClick={(e) => setStatus("approved")}
                  >
                    <i className="far fa-vote-yea" /> &nbsp;{t('approved')}
                  </InlineTabContentProduct>
                  <InlineTabContentProduct
                    alias="?filter=reviewing"
                    actived={status === "reviewing"}
                    onClick={(e) => setStatus("reviewing")}
                  >
                    <i className="far fa-eye" /> &nbsp; {t('reviewing')}
                  </InlineTabContentProduct>
                  <InlineTabContentProduct
                    alias="?filter=rejected"
                    actived={status === "rejected"}
                    onClick={(e) => setStatus("rejected")}
                  >
                    <i className="far fa-vote-nay" /> &nbsp;{t('rejected')}
                  </InlineTabContentProduct>
                </InlineTabProduct>
              </div>
            </div>
          </SectionBlock>
        </div>
      </div>
    </Content>
  );
}

function RenderData({ items }: { items: any[] }) {
  const { t } = useTranslation()
  if (items.length === 0) return <div></div>;

  return (
    <table className="table table-padded">
      <tbody>
        {items.map((x, i) => {
          return (
            <tr key={i}>
              <td className="text-center" style={{ width: 100 }}>
                <img src={x.banner} alt="" width={50} height={50} />
              </td>
              <td>
                <b style={{ color: "#636c72" }}>{x.name}</b>
              </td>
              <td>
                <small className="text-muted">{x.description}</small>
              </td>
              <td className="text-center" style={{ width: 100 }}>
                <Link
                  to={`/options/brand/edit/${x.id}`}
                  className="btn btn-primary btn-sm"
                >
                  {t('edit')}
                </Link>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
